"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARKETS = void 0;
exports.MARKETS = [
    {
        address: "475P8ZX3NrzyEMJSFHt9KCMjPpWBWGa6oNxkWcwww2BR",
        name: "BTC-PERP",
    },
    {
        address: "3ds9ZtmQfHED17tXShfC1xEsZcfCvmT8huNG79wa4MHg",
        name: "ETH-PERP",
    },
    {
        address: "jeVdn6rxFPLpCH9E6jmk39NTNx2zgTmKiVXBDiApXaV",
        name: "SOL-PERP",
    },
];
//# sourceMappingURL=markets.js.map